<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="headline">Dashboard</div>
                
                <v-row>
                    <v-col v-for="(delivery, index) in deliveries" :key="index" cols="12" md="6" lg="3">
                        <v-card :class="[delivery.color, 'white--text', 'dcard']">
                            <v-card-title primary-title>
                                <v-row>
                                    <v-col cols="2">
                                        <v-icon x-large dark>{{delivery.icon}}</v-icon>
                                    </v-col>

                                    <!-- <v-spacer></v-spacer> -->
                                    <v-col>
                                        <div class="text-right display-1">{{delivery.count}}</div>
                                        <div class="text-right title font-weight-light">{{delivery.msg}}</div>
                                    </v-col>
                                </v-row>
                            </v-card-title>
                        </v-card>

                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
// import axios from "axios";
import moment from "moment";
export default {
    data() {
        return {
            deliveriesToday: [],
            deliveries: [
                // {
                //     msg: "leveranser for tidlig",
                //     count: 1,
                //     color: "amber", // #f0ad4e
                //     icon: "mdi-timer-sand-full"
                // }
            ]
        };
    },
    async mounted() {
        // this.axios
        //     .get(
        //         `/delivery?start=${moment().startOf('week').unix()}&end=${moment().endOf('week').unix()}`
        //     )
        //     .then(response => {
        //         if(response.data.success){
        //             let deliveries = response.data.data;

        //             console.log(deliveries);

        //             debugger;
        //         }
        //     });

        this.axios
            .get(
                `/delivery?start=${moment()
                    .startOf("week")
                    .unix()}&end=${moment()
                    .endOf("week")
                    .unix()}`
            )
            .then(response => {
                if (response.data.success) {
                    this.deliveriesToday = response.data.data;

                    this.deliveries.push({
                        msg: "leveranser i uken",
                        count: this.deliveriesToday.length,
                        color: "light-blue", // #337ab7
                        icon: "mdi-calendar-today"
                    });
                }
            });

        this.axios
            .get(
                `/delivery?start=${moment()
                    .startOf("week")
                    .unix()}&end=${moment()
                    .endOf("week")
                    .unix()}`
            )
            .then(response => {
                if (response.data.success) {
                    let del = response.data.data;
                    // console.log(del.length);
                    this.deliveries.push({
                        msg: "leveranser ikke levert",
                        count: del.filter(d => d.inAccessCode.claims == 0).length,
                        color: "red", // #d9534f
                        icon: "mdi-timer-sand-empty"
                    });
                }
            });

        this.axios
            .get(
                `/delivery?start=${moment()
                    .startOf("week")
                    .unix()}&end=${moment()
                    .endOf("week")
                    .unix()}`
            )
            .then(response => {
                if (response.data.success) {
                    let del = response.data.data;
                    // console.log(del.length);
                    this.deliveries.push({
                        msg: "leveranser i tide",
                        count: del.filter(d => d.inAccessCode.claims > 0).length,
                        color: "green", // #5cb85c
                        icon: "mdi-truck"
                    });
                }
            });
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
[v-cloak] {
    display: none;
}
.dcard {
    min-width: 245px;
    border-radius: 15px !important;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
</style>
